import React from "react"
import Title from "./Title"
import { FaAngleDoubleRight, FaAlignRight } from "react-icons/fa"
import { graphql, useStaticQuery } from "gatsby"
import { Link } from "gatsby"
export const query = graphql`
  {
    __typename
    allStrapiJobs(sort: { fields: strapiId, order: ASC }) {
      nodes {
        company
        position
        Date
        desc {
          id
          name
        }
        strapiId
      }
    }
  }
`
const Jobs = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiJobs: { nodes: jobs },
  } = data
  console.log(jobs)
  const [value, setValue] = React.useState(0)
  const { company, Date, desc, position, strapiId } = jobs[value]
  return (
    <section className="section jobs">
      <Title title="experience" />
      {/* btn container*/}
      <div className="jobs-center">
        <div className="btn-container">
          {jobs.map((item, index) => {
            return (
              <button
                key={item.strapiId}
                className={`job-btn ${index === value && "active-btn"} `}
                onClick={() => setValue(index)}
              >
                {item.company}
              </button>
            )
          })}
        </div>

        {/* job-info*/}
        <article className="job-info">
          <h3>{position}</h3>
          <h4>{company}</h4>
          <p className="job-date">
            {Date} {strapiId === 1 ? "- Present" : ""}
          </p>
          {desc.map(description => {
            return (
              <div className="job-desc" key={description.id}>
                <FaAlignRight className="job-icon"></FaAlignRight>
                <p>{description.name}</p>
              </div>
            )
          })}
        </article>
      </div>
      <Link to="/about" className="btn center-btn">
        More Info
      </Link>
    </section>
  )
}

export default Jobs
